import { getProductsCompareOrchestratorHost } from 'common/selectors/env';
import { getCustomerID } from 'common/selectors/cookies';
import { select, put, call, cancelled } from 'redux-saga/effects';
import { PRODUCTS_COMPARE_MANAGE, PRODUCTS_COMPARE_SET_ACTIVE_GROUP_ID } from '../actions';
import { ProductErrorState, CompareListsFromAPI } from '../types';
import { createClientCookies } from 'utils';
import { getLists } from '../api';
import { api } from 'api';
import { transformCompareListsFromAPI } from '../utils';
import { getActiveGroupId } from '../selectors/base';
import { CUSTOMER_ID_COOKIE_NAME, YM_UID_COOKIE_NAME } from '../constants';

const EMPTY_PRODUCT_ID = '';
const EMPTY_GROUP_ID = '';

/**
 * NOTE: Сага для загрузки списков сравнения товаров
 * Обрабатывает получение данных с API, их трансформацию и установку активной группы
 */
export function* fetchCompareListsSaga(): Generator {
  const abortToken = yield call([api, 'abortController']);
  const clientSideCookie = createClientCookies();
  try {
    const customerId = __IS_SERVER__
      ? yield select(getCustomerID)
      : clientSideCookie.get(CUSTOMER_ID_COOKIE_NAME) || clientSideCookie.get(YM_UID_COOKIE_NAME);
    if (!customerId) {
      yield put(PRODUCTS_COMPARE_MANAGE.success({}));
      return;
    }

    const host: string = yield select(getProductsCompareOrchestratorHost);
    const apiData: CompareListsFromAPI = yield call(getLists, customerId, host, abortToken.token);
    const unifiedData = transformCompareListsFromAPI(apiData);

    yield put(PRODUCTS_COMPARE_MANAGE.success(unifiedData));

    if (apiData.length > 0) {
      const activeGroupId = yield select(getActiveGroupId);
      const firstGroupId = apiData[0]?.groupId;

      if (!activeGroupId && firstGroupId) {
        yield put(PRODUCTS_COMPARE_SET_ACTIVE_GROUP_ID(firstGroupId));
      }
    }
  } catch (error) {
    const err = error instanceof Error ? error : new Error(`Неизвестная ошибка: ${String(error)}`);

    const errorState: ProductErrorState = {
      error: err,
      productId: EMPTY_PRODUCT_ID,
      groupId: EMPTY_GROUP_ID,
    };

    yield put(PRODUCTS_COMPARE_MANAGE.failure(errorState));

    const customerId: string | null = yield select(getCustomerID);
    // eslint-disable-next-line no-console
    console.error('Ошибка загрузки списков сравнения:', {
      message: err.message,
      stack: err.stack,
      customerId,
      timestamp: new Date().toISOString(),
    });
  } finally {
    if ((yield cancelled()) as boolean) abortToken.cancel();
  }
}
